import React, { useState, useEffect, useContext, useCallback } from 'react'
import { strCol, numCol, dateCol, intCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
// import styled from 'styled-components'
import CommonScreen from 'admin/component/CommonScreen'
import { ErrorContext } from 'context'
import moment from 'moment'
import {
  getWindSubgroup,
  getWindUtilityOperatorInfo,
  getWindRegion,
  getWindCountry,
  getStateCountry,
  getWindRegime,
  getWindScada,
  getWindTurbineManufacture,
  getWindTurbulence,
  getWindShear,
  getWindOwnershipStatus,
  saveWindSubgroup,
  deleteWindSubgroup,
  getWindPlantInfo,
} from 'api/pgads'
import { Select, Input, InputNumber, DatePicker, Modal } from 'antd'

const title = 'Wind Subgroup'

const retrieveTask = apiTargetInfo => getWindSubgroup(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  saveWindSubgroup(apiTargetInfo)(data) // our api only accpets arrays of data

const deleteTask = apiTargetInfo => data =>
  deleteWindSubgroup(apiTargetInfo)(data) // our api only accpets arrays of data

const WindSubgroup = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [utilityList, setUtilityList] = useState([])
  const [utilityMap, setUtilityMap] = useState({})
  const [regionMap, setRegionMap] = useState({})
  const [countryMap, setCountryMap] = useState({})
  const [stateMap, setStateMap] = useState({})
  const [regimeMap, setRegimeMap] = useState({})
  const [scadaMap, setScadaMap] = useState({})
  const [turbineMap, setTurbineMap] = useState({})
  const [turbulenceMap, setTurbulenceMap] = useState({})
  const [shearMap, setShearMap] = useState({})
  const [ownershipStatusMap, setOwnershipStatusMap] = useState({})
  const [plantMap, setPlantMap] = useState({})
  useEffect(
    _ => {
      getWindPlantInfo(apiTargetInfo).fork(setError, data => {
        const plantMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.plantIdName]: d.plantIdName }))
        )
        setPlantMap(plantMap)
      })

      getWindUtilityOperatorInfo(apiTargetInfo).fork(setError, data => {
        setUtilityList(data)
        const utilityMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.utility]: d.utilityName || d.utility }))
        )
        setUtilityMap(utilityMap)
      })

      getWindRegion(apiTargetInfo).fork(setError, data => {
        const regionMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.regionId]: d.regionName }))
        )
        setRegionMap(regionMap)
      })

      getWindCountry(apiTargetInfo).fork(setError, data => {
        const countryMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.countryId]: d.countryName }))
        )
        setCountryMap(countryMap)
      })

      getStateCountry(apiTargetInfo).fork(setError, data => {
        const countryMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.stateId]: d.stateName }))
        )
        setStateMap(countryMap)
      })

      getWindRegime(apiTargetInfo).fork(setError, data => {
        const regimeMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windRegimeId]: d.windRegime }))
        )
        setRegimeMap(regimeMap)
      })

      getWindScada(apiTargetInfo).fork(setError, data => {
        const scadaMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.windScadaManufacturerId]: d.windScadaManufacturer,
          }))
        )
        setScadaMap(scadaMap)
      })

      getWindTurbineManufacture(apiTargetInfo).fork(setError, data => {
        const turbineMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.windTurbineManufacturerId]: d.windTurbineManufacturer,
          }))
        )
        setTurbineMap(turbineMap)
      })

      getWindTurbulence(apiTargetInfo).fork(setError, data => {
        const turbulence = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windTurbulenceId]: d.windTurbulence }))
        )
        setTurbulenceMap(turbulence)
      })

      getWindShear(apiTargetInfo).fork(setError, data => {
        const turbulence = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windShearId]: d.windShear }))
        )
        setShearMap(turbulence)
      })

      getWindOwnershipStatus(apiTargetInfo).fork(setError, data => {
        const status = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windOwnershipStatusId]: d.windOwnershipStatus }))
        )
        setOwnershipStatusMap(status)
      })
    },
    [apiTargetInfo, setError]
  )

  const headers = WindSubgroupHeaders.map(hdr =>
    hdr.ident === 'utility'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            utilityMap[value] ? value + '-' + utilityMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            utilityMap[rowData.utility] || rowData.utility,
          ...toSelectionColProps(utilityMap),
        }
      : hdr.ident === 'region'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            regionMap[value] ? value + '-' + regionMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            regionMap[rowData.region] || rowData.region,
          ...toSelectionColProps(regionMap),
        }
      : hdr.ident === 'country'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            countryMap[value] ? value + '-' + countryMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            countryMap[rowData.country] || rowData.country,
          ...toSelectionColProps(countryMap),
        }
      : hdr.ident === 'stateProvince'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            stateMap[value] ? value + '-' + stateMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            stateMap[rowData.stateProvince] || rowData.stateProvince,
          ...toSelectionColProps(stateMap),
        }
      : hdr.ident === 'windRegime'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            regimeMap[value] ? value + '-' + regimeMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            regimeMap[rowData.windRegime] || rowData.windRegime,
          ...toSelectionColProps(regimeMap),
        }
      : hdr.ident === 'scadaManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            scadaMap[value] ? value + '-' + scadaMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            scadaMap[rowData.scadaManufacturer] || rowData.scadaManufacturer,
          ...toSelectionColProps(scadaMap),
        }
      : hdr.ident === 'trubineManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            turbineMap[value] ? value + '-' + turbineMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            turbineMap[rowData.trubineManufacturer] ||
            rowData.trubineManufacturer,
          ...toSelectionColProps(turbineMap),
        }
      : hdr.ident === 'turbulenceIntensity'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            turbulenceMap[value] ? value + '-' + turbulenceMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            turbulenceMap[rowData.turbulenceIntensity] ||
            rowData.turbulenceIntensity,
          ...toSelectionColProps(turbulenceMap),
        }
      : hdr.ident === 'windShearId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            shearMap[value] ? value + '-' + shearMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            shearMap[rowData.windShearId] || rowData.windShearId,
          ...toSelectionColProps(shearMap),
        }
      : hdr.ident === 'subgroupOwnershipStatus'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            ownershipStatusMap[value]
              ? value + '-' + ownershipStatusMap[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            ownershipStatusMap[rowData.subgroupOwnershipStatus] ||
            rowData.subgroupOwnershipStatus,
          ...toSelectionColProps(ownershipStatusMap),
        }
      : hdr
  )

  const getLabel = (key, isKey, isRequired) => {
    return (
      <div>
        {isKey && <span style={{ color: 'red', marginRight: '2px' }}>*</span>}
        {!isKey && isRequired && (
          <span style={{ color: 'red', marginRight: '2px' }}>*</span>
        )}
        {WindSubgroupHeaders.find(f => f.ident === key).display}
      </div>
    )
  }

  const getMapSelect = useCallback(
    ({ key, keymap, isKey, setInsertData, insertData, isRequired = false }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Select
          disabled={insertData.insert && isKey}
          style={{ width: '100%', zIndex: 1500 }}
          value={insertData[key]}
          onChange={val => setInsertData({ ...insertData, [key]: val })}
        >
          {Object.keys(keymap).map(k => (
            <Select.Option value={k} key={k}>
              {`${k}-${keymap[k]}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    ),
    []
  )

  const getInput = useCallback(
    ({
      key,
      maxLength,
      isKey,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Input
          disabled={insertData.insert && isKey}
          value={insertData[key]}
          onChange={e =>
            setInsertData({ ...insertData, [key]: e.target.value })
          }
          maxLength={maxLength}
        />
      </div>
    ),
    []
  )

  const getInputNumber = useCallback(
    ({
      key,
      precision = 0,
      isKey = false,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <InputNumber
          disabled={insertData.insert && isKey}
          style={{ width: '100%' }}
          value={insertData[key]}
          onChange={value =>
            setInsertData({ ...insertData, [key]: value + '' })
          }
          precision={precision}
        />
      </div>
    ),
    []
  )

  const getDate = useCallback(
    ({ key, insertData, isKey, setInsertData, isRequired = false }) => (
      <div>
        {getLabel(key, isKey, isRequired)}
        <DatePicker
          style={{ width: '100%' }}
          format="MM/DD/YYYY"
          value={insertData[key + 'date']}
          onChange={d => {
            setInsertData({
              ...insertData,
              [key]: d.format('YYYY-MM-DD'),
              [key + 'date']: d,
            })
          }}
        />
      </div>
    ),
    []
  )

  // const insertSaveData = useCallback(
  //   ({ retrieve, validateData }) => {
  //     if (!validateData()) return
  //     saveWindSubgroup(apiTargetInfo)([insertData]).fork(setError, data => {
  //       setInsertEvent(false)
  //       message.info('Data Saved')
  //       retrieve()
  //     })
  //   },
  //   [apiTargetInfo, insertData, setError]
  // )

  const insertModal = ({
    // retrieve,
    // validateData,
    setInsertData,
    insertData,
    onAdd,
    onCancel,
  }) => (
    <Modal
      centered
      maskClosable={false}
      afterClose={_ => onCancel(false)}
      okText="Save"
      zIndex={500}
      destroyOnClose
      title="Insert data"
      // onOk={_ => insertSaveData({ retrieve, validateData })}
      onOk={_ => onAdd(false)}
      onCancel={_ => setInsertEvent(false)}
      visible={insertEvent}
      bodyStyle={{ width: 'auto', overflowX: 'auto' }}
      width={1300}
    >
      <div
        style={{
          minHeight: '300px',
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 200px 200px 200px',
          gridTemplateRows: '60px 60px 60px 60px',
          gridColumnGap: '5px',
          gridRowGap: '7px',
        }}
      >
        {getMapSelect({
          key: 'utility',
          keymap: utilityMap,
          isKey: true,
          setInsertData,
          insertData,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'plantIdName',
          isKey: true,
          keymap: plantMap,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'groupIdName',
          isKey: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'subgroupId',
          min: 0,
          isKey: true,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'subgroupName',
          isKey: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'commissionYear',
          min: 0,
          precision: 0,
        })}
        {getDate({
          setInsertData,
          insertData,
          key: 'effectiveDate',
          isRequired: true,
        })}

        {getMapSelect({
          setInsertData,
          insertData,
          key: 'country',
          keymap: countryMap,
          isRequired: true,
        })}

        {getMapSelect({
          setInsertData,
          insertData,
          key: 'region',
          keymap: regionMap,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'stateProvince',
          keymap: stateMap,
        })}
        {getInput({ setInsertData, insertData, key: 'nearestCity' })}
        {getInput({ setInsertData, insertData, key: 'isoResourceId' })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'subgroupOwnershipStatus',
          keymap: ownershipStatusMap,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'latitude',
          min: 0,
          precision: 4,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'longitude',
          min: 0,
          precision: 4,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'elevation',
          min: 0,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'windRegime',
          keymap: regimeMap,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'annualAvgWindspeed',
          min: 0,
          precision: 2,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'totalInstalledCap',
          min: 0,
          precision: 3,
          isRequired: true,
        })}

        {getInputNumber({
          setInsertData,
          insertData,
          key: 'numberTurbines',
          min: 0,
          precision: 0,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'trubineSystemMw',
          min: 0,
          precision: 3,
          isRequired: true,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'reserveCap',
          min: 0,
          precision: 3,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'scadaManufacturer',
          keymap: scadaMap,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'scadaModel',
          maxLength: 10,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'maxTurbineCapacity',
          min: 0,
          precision: 3,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'trubineManufacturer',
          keymap: turbineMap,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'trubineModel',
          maxLength: 20,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'trubineModelVersion',
          maxLength: 20,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'rotorHeight',
          min: 0,
          precision: 2,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'rotorDiameter',
          min: 0,
          precision: 2,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'cutInWindspeed',
          min: 0,
          precision: 2,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'lowCutOutWindspeed',
          min: 0,
          precision: 2,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'highCutOutWindspeed',
          min: 0,
          precision: 2,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'turbulenceIntensity',
          keymap: turbulenceMap,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'avgWindspeed',
          min: 0,
          precision: 2,
        })}
        {getMapSelect({
          setInsertData,
          insertData,
          key: 'windShearId',
          keymap: shearMap,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'refAnemometerHeight',
          min: 0,
          precision: 0,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'minOperatingTemp',
          min: 0,
          precision: 0,
        })}
        {getInputNumber({
          setInsertData,
          insertData,
          key: 'maxOperatingTemp',
          min: 0,
          precision: 0,
        })}
        {getInput({
          setInsertData,
          insertData,
          key: 'transferToUtility',
          maxLength: 10,
        })}
        <div />
      </div>
    </Modal>
  )
  const sortOnData = data => {
    return data.map(d => {
      let eff = d.effectiveDate
      if (eff && eff.length > 0) eff = moment(eff).format('MM/DD/YYYY')
      return { ...d, effectiveDate: eff }
    })
  }
  const modifySaveDataBeforeSave = data => {
    return data.map(d => {
      let eff = d.effectiveDate
      if (eff && eff.length > 0)
        eff = moment(eff, 'MM/DD/YYYY').format('YYYY-MM-DD')
      return { ...d, effectiveDate: eff }
    })
  }

  return (
    <div>
      {/* {insertEvent && <InsertModal />} */}

      <CommonScreen
        modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        sortOnData={sortOnData}
        title={title}
        header={headers}
        saveTask={modifyTask}
        retrieveTask={retrieveTask}
        deleteTask={deleteTask}
        // autoFixColByKey={false}
        // altBy={d => d.utility}
        autoRetrieve
        // sortOptions={[
        //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
        //   { ident: 'unitName', display: 'Unit Name', sortOrder: 'asc' },
        //   { ident: 'unit', display: 'Unit Code', sortOrder: 'asc' },
        // ]}
        //        sortOptions={headerWithFormatter.map(e => ({ ...e, sortOrder: 'asc' }))}
        insertComp={insertEvent ? insertModal : false}
        // insertCompHeight={150}
        onInsertEvent={v => {
          setInsertEvent(v)
          // setInsertModal(v)
          // setInsertData({ insert: true })
        }}
        headerRowHeight={60}
      />
    </div>
  )
}
const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(WindSubgroup)

const WindSubgroupHeaders = [
  strCol({ ident: 'utility', display: 'Utility', isKey: true, width: 300 }),
  strCol({
    ident: 'plantIdName',
    display: 'Plant ID/Name',
    isKey: true,
    width: 300,
  }),
  strCol({
    ident: 'groupIdName',
    display: 'Group ID/Name',
    isKey: true,
    width: 180,
  }),
  intCol({ ident: 'subgroupId', display: 'Subgroup ID', isKey: true }),
  strCol({
    ident: 'subgroupName',
    display: 'Subgroup Name',
    isFiltered: true,
    width: 200,
  }),
  strCol({ ident: 'region', display: 'Region', isFiltered: true, width: 350 }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  strCol({
    ident: 'isoResourceId',
    display: 'ISO ID',
    isFiltered: true,
  }),
  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({ ident: 'nearestCity', display: 'Nearest City', isFiltered: true }),
  strCol({
    ident: 'stateProvince',
    display: 'State Province',
    isFiltered: true,
    width: 200,
  }),
  numCol({ ident: 'latitude', display: 'Latitude(DD)', isFiltered: true }),
  numCol({ ident: 'longitude', display: 'Longitude(DD)', isFiltered: true }),
  intCol({ ident: 'elevation', display: 'Elevation(m)', isFiltered: true }),
  intCol({ ident: 'windRegime', display: 'Wind Regime', isFiltered: true }),
  numCol({
    ident: 'annualAvgWindspeed',
    display: 'Annual Avg Windspeed(m/s)',
    isFiltered: true,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 150,
  }),
  strCol({ ident: 'scadaModel', display: 'SCADA Model', isFiltered: true }),
  intCol({
    ident: 'commissionYear',
    display: 'Commission Year(yyyy)',
    isFiltered: true,
  }),
  numCol({
    ident: 'totalInstalledCap',
    display: 'Total Installed Cap(MW)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({ ident: 'reserveCap', display: 'Reserve Cap(MW)', isFiltered: true }),
  intCol({
    ident: 'numberTurbines',
    display: 'Number Of Turbines',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'trubineSystemMw',
    display: 'Turbine System MW',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxTurbineCapacity',
    display: 'Max Turbine Capacity(MW)',
    isFiltered: true,
  }),
  strCol({
    ident: 'trubineManufacturer',
    display: 'Turbine Manufacturer',
    isFiltered: true,
    width: 150,
  }),
  strCol({ ident: 'trubineModel', display: 'Turbine Model', isFiltered: true }),
  strCol({
    ident: 'trubineModelVersion',
    display: 'Turbine Model Version',
    isFiltered: true,
  }),
  numCol({
    ident: 'rotorHeight',
    display: 'Rotor Height(m)',
    isFiltered: true,
  }),
  numCol({
    ident: 'rotorDiameter',
    display: 'Rotor Diameter(m)',
    isFiltered: true,
  }),
  numCol({
    ident: 'cutInWindspeed',
    display: 'Cut-In Wind Speed(m/s)',
    isFiltered: true,
  }),
  numCol({
    ident: 'lowCutOutWindspeed',
    display: 'Low Cut-Out(m/s)',
    isFiltered: true,
  }),
  numCol({
    ident: 'highCutOutWindspeed',
    display: 'High Cut-Out(m/s)',
    isFiltered: true,
  }),
  intCol({
    ident: 'turbulenceIntensity',
    display: 'Turbulence Intensity',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'avgWindspeed',
    display: 'Avg Wind Speed(m/s)',
    isFiltered: true,
  }),
  intCol({
    ident: 'windShearId',
    display: 'Wind Shear (Opt)',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'refAnemometerHeight',
    display: 'Ref Anemometer Height (Opt)',
    isFiltered: true,
  }),
  intCol({
    ident: 'minOperatingTemp',
    display: 'Min Operating Temp (?C)',
    isFiltered: true,
  }),
  intCol({
    ident: 'maxOperatingTemp',
    display: 'Max Operating Temp (?C)',
    isFiltered: true,
  }),
  strCol({
    ident: 'subgroupOwnershipStatus',
    display: 'Ownership Status',
    isFiltered: true,
    isRequired: true,
  }),

  strCol({
    ident: 'transferToUtility',
    display: 'Transfer To Utility ID',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
].map(h => (h.width ? h : { ...h, width: 150 }))
